import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getAgencyDocumentsPagination } from 'redux/actions/agency-resource-actions';
import { dateFormatMyDocuments } from 'helper/helperFunctions';
import User from 'helper/User';
import { SC } from 'helper/ServerCall';
import { pathSegment } from 'helper/queryString';
import AgencyFolder from '../../Admin/AgencyFolder';

class GlobalDocuments extends Component {
    constructor(props) {
        super(props)
        this._isMounted = false;
        this.state = {
            agencyDocuments: [],
            length:false,
            agency_folder_id: null,
            callData: [],
            addFolderModal: false,
            folderName: '',
            selectedFolder: 'No Folder Selected',
            expanded: [],
            is_folder: true,
            folders:[]
        }
    }

    safeSetState = (state, callback) => {
        if (this._isMounted) {
            this.setState(state, callback);
        }
    }

    canLoadAgencyData = () => {
        return this._isMounted
            && User.isAuthenticated()
            && this.props.agency_id;
    }

    getAgencyFolderResources = (id) => {
        return SC.getCall(`getAgencyFolderResources/${pathSegment(id)}`);
    }

    loadAgencyFolderResources = () => {
        const agency_id = this.props.agency_id;
        if (!this.canLoadAgencyData() || !agency_id) {
            return;
        }
        this.getAgencyFolderResources(agency_id).then(response => {
            if (!this.canLoadAgencyData() || !response || !response.data) {
                return;
            }
            const folder = response.data.folder_array;
            if (!folder || typeof folder !== 'object') {
                return;
            }
            const ids = [];
            Object.keys(folder).map((item) => {
                if (!(folder[item].value == "-1")) {
                    ids.push(folder[item].value.toString());
                }
            });
            this.safeSetState({
                expanded: ids,
                callData: response.data.data || [],
                folders: response.data.folder_array
            });
        }).catch(() => {});
    }

    loadAgencyDocuments = () => {
        const agency_id = this.props.agency_id;
        if (!this.canLoadAgencyData() || !agency_id) {
            return;
        }
        this.props.getAgencyDocumentsPaginationCall(agency_id).then(response => {
            if (!this.canLoadAgencyData() || !Array.isArray(response) || response.length === 0) {
                return;
            }
            this.safeSetState({
                agencyDocuments: response,
                length: response.length
            }, () => {
                if (this.props.parentCallback) {
                    this.props.parentCallback(this.state.length);
                }
            });
        }).catch(() => {});
    }

    componentDidMount() {
        this._isMounted = true;
        this.loadAgencyFolderResources();
        this.loadAgencyDocuments();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onFolderClick = (e, data, nodes, nodeId) => {
        const expandingNodes = nodes;
        this.safeSetState({
            expanded:expandingNodes,
            selectedFolder: data.folder_name,
            order_folder_id: data.folder_id,
            is_folder: true
        })
    }

    render() {
        const { callData, expanded } = this.state;
        return (
            <div>
                    {
                        callData ?
                        <>
                            <div className="flexElem respFlex spaceBetween form_tile_row mb-md">
                                <div className="col-md-12">
                                    <div className="flexElem mb-md">
                                        <span className="form_tile_title">Agency Documents</span>
                                        <p className="smallText">Will appear on all orders.</p>
                                    </div>
                                </div>
                            </div>
                            {
                                callData.map((item, key) => {
                                if (item.folder_id){
                                    return (
                                        <AgencyFolder key={item.folder_id || key} item = {item} ex = {expanded} onFolderClick = {this.onFolderClick} noDelete = {false} dragable = {false} />
                                    )
                                }
                                return null;
                                })
                            }

                            <div className="flexElem respFlex spaceBetween form_tile_row">
                                <div className="col-md-12">
                                    <div className="table-responsive">

                                        <table className="table_tile mb-md">
                                            <thead>
                                                <tr className="border-bottom">
                                                    <th width="35%">File Name</th>
                                                    <th width="25%">Uploaded Date</th>
                                                    <th width="20%">Status</th>
                                                    <th width="20%">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                callData.map((item, index) => {
                                                    if (item.file_path) {
                                                        return(
                                                            <tr key={item.id}>
                                                                <td><a style={{ wordBreak: 'break-all' }} className='blue_link' target="_blank" href={item.file_path} rel="noopener noreferrer">{item.original_file_name}</a></td>
                                                                <td>{dateFormatMyDocuments(item.created_at)}</td>
                                                                <td>{item.is_scheduled === 1 ? 'Scheduled' : 'Sent'}</td>
                                                                <td>
                                                                    <a className='ml-md' href={item.file_path}><i className='fa fa-download'></i></a>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }else{
                                                        return null;
                                                    }
                                                    })
                                                }
                                            </tbody>
                                        </table>


                                        </div>
                                    </div>
                                </div>
                        </>
                        : ''
                    }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAgencyDocumentsPaginationCall: (agency_id) => { return dispatch(getAgencyDocumentsPagination(agency_id)) },
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GlobalDocuments))
